// Shared utilities for Markets widgets

/**
 * Format a symbol for use in URLs (e.g., BTC/USD -> BTC-USD)
 */
export const formattedSymbol = (symbol) => symbol.replace('/', '-');

/**
 * Animation variants for framer-motion
 * Original timing: { duration: 0.5, ease: 'easeOut' }
 */
export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.1
    }
  }
};